var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container container_40 manage-orders" },
    [
      _c("div", { staticClass: "text_large" }, [
        _vm._v(
          _vm._s(
            _vm.i18n.trd_manage({
              pair: _vm.assets.base + "/" + _vm.assets.quote
            })
          )
        )
      ]),
      _vm._v(" "),
      _vm.offers.length
        ? [
            _c(
              "md-table",
              { staticClass: "manage-orders__table scrollbar" },
              [
                _c(
                  "md-table-row",
                  { staticClass: "manage-orders__row" },
                  [
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.trd_manage_date()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.trd_manage_market()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.trd_manage_order()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.trd_manage_base_asset_amount()))
                    ]),
                    _vm._v(" "),
                    _c("md-table-head", [
                      _vm._v(_vm._s(_vm.i18n.trd_manage_quote_asset_price()))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.offers, function(order, i) {
                  return [
                    _c(
                      "md-table-row",
                      {
                        key: i + "-row",
                        staticClass: "manage-orders__row",
                        on: {
                          click: function($event) {
                            return _vm.toggleDetails(i)
                          }
                        }
                      },
                      [
                        _c("md-table-cell", { staticClass: "text_medium" }, [
                          _vm._v(_vm._s(_vm.i18n.d(order.createdAt)))
                        ]),
                        _vm._v(" "),
                        _c("md-table-cell", { staticClass: "text_medium" }, [
                          _vm._v(
                            _vm._s(
                              order.baseAssetCode + "/" + order.quoteAssetCode
                            ) + "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("md-table-cell", { staticClass: "text_medium" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                order.isBuy
                                  ? _vm.i18n.trd_order_buy()
                                  : _vm.i18n.trd_order_sell()
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("md-table-cell", { staticClass: "text_medium" }, [
                          _vm._v(
                            _vm._s(
                              _vm.roundCurrency(
                                order.baseAmount,
                                order.baseAssetCode
                              )
                            ) + "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("md-table-cell", { staticClass: "text_medium" }, [
                          _vm._v(
                            _vm._s(
                              _vm.roundCurrency(
                                order.price,
                                order.quoteAssetCode
                              )
                            ) + "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "md-table-cell",
                          [
                            _c(
                              "md-button",
                              {
                                staticClass:
                                  "manage-orders__open-details-btn md-icon-button"
                              },
                              [
                                _vm.isSelected(i)
                                  ? _c("md-icon", [_vm._v("keyboard_arrow_up")])
                                  : _c("md-icon", [
                                      _vm._v("keyboard_arrow_down")
                                    ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isSelected(i)
                      ? _c(
                          "md-table-row",
                          {
                            key: i + "-expand",
                            staticClass: "manage-orders__expandable-row"
                          },
                          [
                            _c(
                              "md-table-cell",
                              { attrs: { colspan: "7" } },
                              [
                                _c("order-details", {
                                  staticClass: "manage-orders__details",
                                  attrs: { tx: order }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "container__no-data" },
              [
                _c("md-icon", { staticClass: "md-size-4x" }, [
                  _vm._v("trending_up")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text_large" }, [
                  _vm._v(_vm._s(_vm.i18n.trd_no_orders_history()))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text_description text_margin text_medium" },
                  [_vm._v(_vm._s(_vm.i18n.trd_here_will_be_the_order_list()))]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88e48a50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88e48a50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/manageOrders/Trade.ManageOrders.vue
// module id = R5T4
// module chunks = 1